import { faIR } from "../../../../date-fns/locale/fa-IR.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    faIR
  }
};